import Component from '@glimmer/component';
import { array, hash } from '@ember/helper';
import { t } from 'ember-intl';
import {
  HdsPageHeader,
  HdsTable,
} from '@hashicorp/design-system-components/components';
import { CoreLayoutMain, BreadcrumbsContainer } from 'core/components';

/**
 * Contains the `role` and 'organization'.
 * @argument model
 * @type {Object}
 */
/**
 *
 * `PageRolesDetailComponent` renders the details of a role and its nested permissions.
 *
 *
 * ```
 * <Page::Roles::Detail
 *   @model={{model}}
 * />
 * ```
 *
 * @class PageRolesDetailComponent
 *
 */
export default class PageRolesDetail extends Component {
  <template>
    <CoreLayoutMain>
      <:header>
        <HdsPageHeader as |PH|>
          <PH.Breadcrumb>
            <BreadcrumbsContainer />
          </PH.Breadcrumb>
          <PH.Title data-test-role-detail-page-title>
            {{@model.role.title}}
            {{t
              "components.page.access-control.roles.detail.header.permissions"
            }}
          </PH.Title>
          <PH.Description data-test-role-detail-page-title-description>
            {{@model.role.description}}
          </PH.Description>
        </HdsPageHeader>
      </:header>
      <:body>
        <div class="roles-detail" data-test-role-details>
          <section>
            <HdsTable
              @model={{@model.role.permissions}}
              @columns={{array
                (hash
                  key="service"
                  label=(t
                    "components.page.access-control.roles.detail.table.headers.service"
                  )
                  isSortable=true
                )
                (hash
                  key="resource"
                  label=(t
                    "components.page.access-control.roles.detail.table.headers.resource"
                  )
                  isSortable=true
                )
                (hash
                  key="action"
                  label=(t
                    "components.page.access-control.roles.detail.table.headers.action"
                  )
                  isSortable=true
                )
              }}
              @valign="middle"
            >
              <:head as |H|>
                <H.Tr>
                  <H.Th>
                    {{t
                      "components.page.access-control.roles.detail.table.headers.service"
                    }}
                  </H.Th>
                  <H.Th>
                    {{t
                      "components.page.access-control.roles.detail.table.headers.resource"
                    }}
                  </H.Th>
                  <H.Th>
                    {{t
                      "components.page.access-control.roles.detail.table.headers.action"
                    }}
                  </H.Th>
                </H.Tr>
              </:head>
              <:body as |B|>
                <B.Tr data-test-role-key-permission-item>
                  <B.Td data-test-role-key-item-permission-service>
                    {{B.data.service}}
                  </B.Td>
                  <B.Td data-test-role-key-item-permission-resource>
                    {{B.data.resource}}
                  </B.Td>
                  <B.Td data-test-role-key-item-permission-action>
                    {{B.data.action}}
                  </B.Td>
                </B.Tr>
              </:body>
            </HdsTable>
          </section>
        </div>
      </:body>
    </CoreLayoutMain>
  </template>
}
